import Lottie from 'lottie-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import buttonLoading from '../../animations/buttonLoading.json';
import { useProductForm } from '../../contexts/ProductFormContext';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getProduct, updateProduct } from '../../redux/slices/productSlice';
import { getErrorMessage } from '../../utils/errorHandler';
import { validateForm } from '../../utils/validateForm';
import { BasicInfoTab } from './BasicInfoTab';
import { DescriptionTab } from './DescriptionTab';
import { SeoTab } from './SeoTab';
import { SpecTab } from './SpecTab';
import { VariantTab } from './VariantTab';

type PropTypes = {
  onBack: () => void;
  selectedId: string;
};
export const UpdateProductContent = ({ onBack, selectedId }: PropTypes) => {
  const dispatch = useAppDispatch();
  const { productVariant } = useAppSelector(state => state.product);
  const { product, setProduct, setSelectedCategory } = useProductForm();
  useEffect(() => {
    dispatch(getProduct(selectedId));
  }, [dispatch, selectedId]);

  useEffect(() => {
    if (productVariant) {
      setProduct(prev => ({
        product: {
          ...prev.product,
          ...productVariant.product,
          categoryId: productVariant.product.categoryId._id,
          brandId: productVariant.product.brandId._id,
        },
        variants: productVariant.variants,
      }));
      setSelectedCategory(productVariant.product.categoryId._id);
    }
  }, [productVariant, setProduct, setSelectedCategory]);

  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const valid = validateForm([
      { value: product.product.name, label: "Tên sản phẩm" },
      { value: product.product.categoryId, label: "Danh mục" },
      { value: product.product.brandId, label: "Thương hiệu" },
      { value: product.product.images, label: "Ảnh sản phẩm", type: "array" },
      { value: product.product.description, label: "Mô tả sản phẩm" },
      { value: product.variants, label: "Biến thể sản phẩm", type: "array" },
    ]);
    if (!valid) return;
    setIsSubmit(true);
    try {
      await dispatch(updateProduct({ id: selectedId, data: product })).unwrap();
      toast.success('Sửa sản phẩm thành công');
      onBack();
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setIsSubmit(false);
    }
  };

  return (
    <div className="p-5">
      <form onSubmit={handleSubmit} className="space-y-2">
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onBack}
            className="text-sm text-blue-500 hover:underline transition-colors duration-300 cursor-pointer"
          >
            Quản lý sản phẩm
          </button>
          <p className="text-sm text-gray-700">/</p>
          <p className="text-sm text-gray-700">Sửa sản phẩm</p>
        </div>
        <BasicInfoTab />
        <SpecTab />
        <VariantTab />
        <DescriptionTab />
        <SeoTab />
        <div className="flex items-center justify-between">
          <div className="">
            <button
              type="button"
              onClick={onBack}
              className="p-2 bg-blue-500 rounded-lg text-sm text-white cursor-pointer hover:bg-blue-600 transition-colors duration-300"
            >
              Quay lại
            </button>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => {
                if (productVariant) {
                  setProduct(prev => ({
                    product: {
                      ...prev.product,
                      ...productVariant.product,
                      categoryId: productVariant.product.categoryId._id,
                      brandId: productVariant.product.brandId._id,
                    },
                    variants: [...prev.variants, ...productVariant.variants],
                  }));
                }
              }}
              className="p-2 bg-red-500 text-sm text-white rounded-lg cursor-pointer hover:bg-red-600 transition-colors duration-300"
            >
              Hủy
            </button>
            {isSubmit ? (
              <Lottie animationData={buttonLoading} loop={true} className="h-10 w-20" />
            ) : (
              <button
                type="submit"
                className="p-2 bg-green-500 text-sm text-white rounded-lg cursor-pointer hover:bg-green-600 transition-colors duration-300"
              >
                Sửa sản phẩm
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};
